import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type CenterState = {
    sendOtp: any;
    verifyOtp: any;
    failOtp: boolean,
    slot:any[];
    booking: any,
    bookingData:any;
    checkoutLoading:boolean;
    bookingValidation:any;
};

let initialState: CenterState = {
    sendOtp: {},
    verifyOtp: "",
    failOtp: false,
    slot: [],
    booking: {},
    bookingData:{},
    checkoutLoading:false,
    bookingValidation:{}
};

const checkoutSlice = createSlice({
    name: "checkout",
    initialState,
    reducers: {
        sendOtpResponse(state, action: PayloadAction<any>) {
            state.sendOtp = action.payload;
        },
        verifyOtpResponse(state, action: PayloadAction<any>) {
            state.verifyOtp = action.payload;
        },
        slotResponse(state, action: PayloadAction<any>) {
            state.slot = action.payload;
        },
        bookingResponse(state, action: PayloadAction<any>) {
            state.booking = action.payload;
        },
        otpFailResponse(state, action: PayloadAction<any>) {
            state.failOtp = action.payload;
        },
        setBookingDataResponse(state, action: PayloadAction<any>) {
            state.bookingData = action.payload;
        },
        setCheckoutLoading(state, action: PayloadAction<any>) {
            state.checkoutLoading = action.payload;
        },
        setBookingValidationResponse(state, action: PayloadAction<any>) {
            state.bookingValidation = action.payload;
        }
    },
});

export const {setBookingValidationResponse, sendOtpResponse, verifyOtpResponse,slotResponse, bookingResponse,otpFailResponse,setBookingDataResponse,setCheckoutLoading} = checkoutSlice.actions;

export default checkoutSlice.reducer;
